import { createSlice } from "@reduxjs/toolkit";
import { STATS_ADV_QUERY } from "Services/statistic";
import Dayjs from "dayjs";
import { getTimeZone } from "../Services/time";
import { ISelectFilters } from "../types/statistic";

interface IStatAdvState {
  loading: boolean;
  dataStatGraph: [];
  errors: any;
  selectFilters: ISelectFilters;
}

const today = Dayjs().format("YYYY-MM-DD");
const lastMonth = Dayjs().add(-1, "month").format("YYYY-MM-DD");

const initialAdvFilters = {
  [STATS_ADV_QUERY.GROUP_BY]: "date_time",
  [STATS_ADV_QUERY.DATE_FROM]: lastMonth,
  [STATS_ADV_QUERY.DATE_TO]: today,
  [STATS_ADV_QUERY.COUNTRIES]: [],
  [STATS_ADV_QUERY.OSES]: [],
  [STATS_ADV_QUERY.COUNTRY_ID]: [],
  [STATS_ADV_QUERY.OS_ID]: [],
  [STATS_ADV_QUERY.SITES]: [],
  [STATS_ADV_QUERY.ZONES]: [],
  [STATS_ADV_QUERY.DIRECTIONS]: [],
  [STATS_ADV_QUERY.REQUEST_VARS]: [],
  [STATS_ADV_QUERY.TIME_ZONE]: getTimeZone(),
};

const initialState: IStatAdvState = {
  loading: false,
  dataStatGraph: [],
  selectFilters: initialAdvFilters,
  errors: {},
};

const statisticAdvSlice = createSlice({
  name: "stat",
  initialState,
  reducers: {
    resetFilters: (state) => {
      state.selectFilters = initialAdvFilters;
    },
    setQuery: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.selectFilters = {
        ...state.selectFilters,
        ...payload,
      };
    },
    setLoader: (state) => {
      state.loading = true;
      state.errors = initialState.errors;
    },
    setStatGraph: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.dataStatGraph = payload.result[0]?.values || [];
    },
    setError: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.errors = payload;
    },
  }
});

export const {
  setLoader,
  setStatGraph,
  setError,
  setQuery,
  resetFilters,
} = statisticAdvSlice.actions;

export default statisticAdvSlice.reducer;
